export default "__VITE_ASSET__DHaamiOH__"